<style scoped>
.message-list {
	max-height: 500px;
	overflow-y: auto;
	padding: 0.5rem;
}
.empty-state {
	text-align: center;
	padding: 2rem;
	color: #6c757d;
}
</style>

<template>
	<div class="card mb-3">
		<div class="card-header d-flex justify-content-between align-items-center">
			<span>
				<i class="bi bi-chat-dots"></i>
				Message History
			</span>
			<span class="badge bg-secondary">
				{{ sortedMessages.length }}
			</span>
		</div>
		<div class="card-body p-0">
			<div v-if="sortedMessages.length === 0" class="empty-state">
				<i class="bi bi-chat-square-text fs-1"></i>
				<p class="mb-0 mt-2">No messages</p>
			</div>
			<div v-else class="message-list">
				<div v-for="(msg, idx) in sortedMessages" :key="idx">
					<MessageBubble :message="msg" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import MessageBubble from "@/components/MessageBubble.vue";
import { Message } from "@/type/api";

interface Props {
	messages: Message[];
}

const props = withDefaults(defineProps<Props>(), {
	messages: () => [],
});

const sortedMessages = computed(() => {
	return [...props.messages].sort(
		(a: Message, b: Message) => a.created.getTime() - b.created.getTime(),
	);
});
</script>
